import { Paperclip } from 'lucide-react';
import { ChangeEvent, useRef, useState } from 'react';

interface CustomFileInputProps {
  name: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  accept?: string;
}

const CustomFileInput = ({
  name,
  onChange,
  className = '',
  accept,
}: CustomFileInputProps) => {
  const [fileName, setFileName] = useState('Sin archivos seleccionados');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files[0]) {
      setFileName(files[0].name);
    } else {
      setFileName('Sin archivos seleccionados');
    }

    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className={`flex items-center ${className}`}>
      <button
        className="flex items-center text-blue-500 hover:text-blue-700 focus:outline-none mr-3"
        type="button"
        onClick={handleClick}
      >
        <Paperclip className="mr-1" size={16} />
        <span className="underline">Adjuntar Archivo</span>
      </button>

      <span className="text-sm text-gray-500">{fileName}</span>

      <input
        ref={fileInputRef}
        accept={accept}
        className="hidden"
        name={name}
        type="file"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default CustomFileInput;
